import React from 'react';
import heroImage from '../assets/images/hero-5.jpg'
import { content } from '../content/hero.content';

const HeroSection = () => (
  <div
    className="relative bg-cover bg-center h-[60vh] flex items-center justify-center text-white"
    style={{ backgroundImage: `url(${heroImage})` }}
  >
    {/* Overlay for dimming the background */}
    <div className="absolute inset-0 bg-black opacity-50"></div>

    {/* Text container */}
    <div className="relative text-center">
      <h1
        className="w-2/3 mx-auto text-5xl font-bold text-secondary leading-tight"
        style={{ textShadow: '2px 2px 8px rgba(0, 0, 0, 0.8)' }}
      >
        {content.description}
      </h1>
    </div>
    
  </div>
);

export default HeroSection;
